import Vue from 'vue'
import VueMeta from 'vue-meta'
import App from './App.vue'
import router from './router/router'
import store from './store/store'
import i18n from './i18n/i18n'
import vuetify from './plugins/vuetify'
import '@/styles/global.scss'

Vue.config.productionTip = false

Vue.use(VueMeta)

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App),
}).$mount('#app')
